import {NgModule} from '@angular/core';
import {CnModule} from "./cn/cn.module";
import {CpModule} from "./cp/cp.module";
import {FeatureProvRoutingModule} from "./feature-prov.routing.module";

@NgModule({
    imports: [
        CnModule,
        CpModule,
        FeatureProvRoutingModule
    ],
    exports: [
        CnModule,
        CpModule
    ]
})
export class FeatureProvModule {
}
